import React, { useState, useEffect } from 'react';
import './EventsPage.css';
import { Link } from 'react-router-dom';
import poster1 from '../assets/images/resized_poster_1.jpg';
import poster2 from '../assets/images/resized_poster_2.jpg';
import poster3 from '../assets/images/resized_poster_3.jpg';
import poster4 from '../assets/images/resized_poster_4.jpg';
import poster5 from '../assets/images/resized_poster_5.jpg';

const posters = [poster5, poster4, poster3, poster2, poster1];

const EventsPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [viewMode, setViewMode] = useState('past'); // 'past' or 'upcoming'

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : 'auto';
  }, [menuOpen]);

  return (
    <div className="events-wrapper">
      {/* Navigation */}
      <header className="events-nav">
      <Link to="/" className="logo-link">
  <h1 className="logo-title static-logo">ATMOS</h1>
</Link>


        <button
          className={`hamburger-icon ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
        <div className={`fullscreen-menu ${menuOpen ? 'open' : ''}`}>
          <ul className="fullscreen-links">
            <li><a href="/" onClick={() => setMenuOpen(false)}>HOME +</a></li>
            <li><a href="/contact" onClick={() => setMenuOpen(false)}>CONTACT US +</a></li>
            <li><a href="/about" onClick={() => setMenuOpen(false)}>ABOUT US +</a></li>
            <li><a href="/about" onClick={() => setMenuOpen(false)}>THE TEAM +</a></li>
          </ul>
        </div>
      </header>

      {/* Toggle Buttons */}
      <section className="events-labels">
        <button
          className={`events-button ${viewMode === 'upcoming' ? 'active' : ''}`}
          onClick={() => setViewMode('upcoming')}
        >
          UPCOMING
        </button>
        <button
          className={`events-button ${viewMode === 'past' ? 'active' : ''}`}
          onClick={() => setViewMode('past')}
        >
          PAST EVENTS
        </button>
      </section>

      {/* Content Section */}
      <section className="poster-gallery">
        {viewMode === 'upcoming' ? (
          <div className="coming-soon-text">
          TBA<span className="dot dot1">.</span>
          <span className="dot dot2">.</span>
          <span className="dot dot3">.</span>
        </div>
        ) : (
          posters.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`Event ${i + 1}`}
              className="event-poster"
            />
          ))
        )}
      </section>
    </div>
  );
};

export default EventsPage;
